import { useMemo } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { resolvePlanId, getPlan, hasFeature, minPlanForFeature } from '@/config/plans';

/**
 * Hook that exposes the effective plan for the current user/workspace
 * and a helper to check feature availability.
 *
 *   const { planId, plan, isLocked } = useCurrentPlan();
 *   isLocked('seo_articles') // true on Starter, false on Pro/Enterprise
 */
export function useCurrentPlan() {
  const { user, workspace } = useAuth();

  return useMemo(() => {
    const planId = resolvePlanId(user, workspace);
    const plan = getPlan(planId);

    const isUnlocked = (featureKey) => hasFeature(planId, featureKey);
    const isLocked = (featureKey) => !isUnlocked(featureKey);

    return {
      planId,
      plan,
      isUnlocked,
      isLocked,
      minPlanFor: minPlanForFeature,
    };
  }, [user, workspace]);
}
